export type AdminBookingAction = 'view' | 'edit' | 'cancel' | 'delete'
export type AdminDestructiveAction = 'delete' | 'cancel'

export const ADMIN_BOOKING_FEEDBACK = {
  cancelled: 'Booking cancelled',
  deleted: 'TEST booking deleted',
  cancelFailed: (reason: string) => `Failed to cancel booking: ${reason}`,
  deleteFailed: (reason: string) => `Failed to delete booking: ${reason}`,
}

export function toAdminBookingSearch(reference: string, action?: AdminBookingAction) {
  return {
    booking: reference,
    action: action === 'edit' ? 'edit' as const : undefined,
  }
}

export function isDestructiveBookingAction(
  action?: AdminBookingAction | null,
): action is AdminDestructiveAction {
  return action === 'delete' || action === 'cancel'
}
